import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import {
  SENSOR_SETTINGS_MAX_SCALE,
  SENSOR_SETTINGS_MIN_SCALE,
  SENSOR_SETTINGS_SELECTABLE_LIST
} from "@/services/consts";


export default /*@__PURE__*/_defineComponent({
  __name: 'SensorSetting',
  props: {
    modelValue: {},
    errors: {},
    isInstallationOffice: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const selectableMax = computed(() => {
  let min = SENSOR_SETTINGS_MIN_SCALE;
  if (props.modelValue.min_scale !== null) min = props.modelValue.min_scale;

  return SENSOR_SETTINGS_SELECTABLE_LIST.filter((value) => {
    return value > min;
  })
})

const selectableMin = computed(() => {
  let max = SENSOR_SETTINGS_MAX_SCALE;
  if (props.modelValue.max_scale !== null) max = props.modelValue.max_scale;

  return SENSOR_SETTINGS_SELECTABLE_LIST.filter((value) => {
    return value < max;
  })
})


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "text-form pl-3 my-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("h6", { class: "pt-2" }, "温度管理グラフのメモリ設定", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "text-form px-3 mt-0 mb-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "d-flex"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "3" }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("h6", { class: "pl-3 pt-4" }, "最大値", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "8" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: modelValue.value.max_scale,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.max_scale) = $event)),
                  density: "compact",
                  variant: "outlined",
                  "hide-details": "auto",
                  suffix: "℃",
                  items: selectableMax.value,
                  "error-messages": __props.errors['sensor_setting.max_scale'],
                  disabled: __props.isInstallationOffice
                }, null, 8, ["modelValue", "items", "error-messages", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "4",
          class: "d-flex"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "3" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("h6", { class: "pl-3 pt-4" }, "最小値", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_col, { col: "8" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: modelValue.value.min_scale,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.min_scale) = $event)),
                  density: "compact",
                  variant: "outlined",
                  "hide-details": "auto",
                  suffix: "℃",
                  items: selectableMin.value,
                  "error-messages": __props.errors['sensor_setting.min_scale'],
                  disabled: __props.isInstallationOffice
                }, null, 8, ["modelValue", "items", "error-messages", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})